import { Component, OnDestroy, OnInit } from '@angular/core';
import { PopoverController } from '@ionic/angular';
import { ToastrService } from 'ngx-toastr';
import { Subscription } from 'rxjs';

import { GeneralToastComponent } from '../../toasts/general-toast/general-toast.component';
import { AnalyticsService } from '../../services/analytics/analytics.service';
import { Take } from '@sc/types';
import { RecordingService } from '../../services/recording/recording.service';

@Component({
  selector: 'sc-edit-take-name-menu',
  templateUrl: './edit-take-name-menu.component.html',
  styleUrls: ['./edit-take-name-menu.component.scss'],
})
export class EditTakeNameMenuComponent implements OnInit, OnDestroy {
  take: Take;
  subs: Array<Subscription> = [];

  constructor(
    private toastrService: ToastrService,
    private popoverController: PopoverController,
    private recordingService: RecordingService,
    private analyticsService: AnalyticsService
  ) {}

  ngOnInit() {}

  async saveTakeName() {
    try {
      await this.recordingService.setTakeName(this.take.takeID, this.take.takeName);
      this.toastrService.success(this.take.takeName, `Successfully edited Take Name`, {
        progressBar: true,
        progressAnimation: 'decreasing',
        closeButton: true,
        tapToDismiss: false,
        timeOut: 5 * 1000,
        toastComponent: GeneralToastComponent,
      });

      await this.popoverController.dismiss();
      await this.analyticsService.track('saved take name', { success: true });
    } catch (error) {
      this.toastrService.error(null, `Failed to edit Take Name`, {
        progressBar: true,
        progressAnimation: 'decreasing',
        closeButton: true,
        tapToDismiss: false,
        timeOut: 5 * 1000,
        toastComponent: GeneralToastComponent,
      });

      await this.popoverController.dismiss();
      await this.analyticsService.track('saved take name', { success: false });
    }
  }

  ngOnDestroy(): void {
    this.subs.map((sub) => sub.unsubscribe());
  }
}
